import { create as createClient } from "axios";
import { CONFIG } from "@/modules/auth/constant/config";
import { errorHandler } from "../middleware/error-handler";
const token = { ...JSON.parse(localStorage.getItem("user")) }.token;

export const UserClient = createClient({
  baseURL: `${CONFIG.BASE_URL}/api/${CONFIG.VERSION}`,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
UserClient.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

UserClient.interceptors.response.use(
  (response) => response,
  (error) => errorHandler(error)
);
